/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesShoesSneakersIcon16Solid = forwardRef('ClothesShoesSneakersIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 3.214a1 1 0 0 1 1.55-.836L8.725 3.81l-1.25 1.925a.625.625 0 1 0 1.05.68l1.244-1.918 1.337.88-1.058 1.63a.625.625 0 0 0 1.049.681l1.053-1.624 2.386 1.57A3.25 3.25 0 0 1 16 10.348V11H0V5.181c0-1.015 1.259-1.488 1.928-.724.44.503.848 1.043 1.586 1.043C4.334 5.5 5 4.835 5 4.014v-.8Z" }),
        React.createElement("path", { d: "M0 12v.25C0 13.216.784 14 1.75 14h12.5A1.75 1.75 0 0 0 16 12.25V12H0Z" })));
});
